import React, { useEffect } from 'react';
import styled from 'styled-components';
import AOS from 'aos';
import 'aos/dist/aos.css';

const RefundPolicy = () => {
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <Wrapper>
      <Header data-aos="fade-down">
        <h1>Refund & Cancellation Policy</h1>
        <p>
          Effective as of July 2025 | Last Updated: July 9, 2025
        </p>
      </Header>

      <Section data-aos="fade-up">
        <h2>Overview</h2>
        <p>
          At Totomart, a property-tech platform powered by Ligiotech Solutions Pvt Ltd, we strive to offer
          exceptional value by providing transparent, brokerage-free property services. Our Refund and Cancellation
          Policy outlines the terms under which users may request refunds or cancellations on our platform.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>Service-Based Refund Policy</h2>
        <p>
          Totomart offers both free and paid property-related services, including but not limited to:
        </p>
        <ul>
          <li>Rental agreement generation</li>
          <li>Home listing promotions</li>
          <li>Tenant verification services</li>
          <li>Rental payment gateway support</li>
        </ul>
        <p>
          Refunds are applicable **only** to failed or incomplete transactions due to technical issues or
          service non-fulfillment from our end. Refund requests must be raised within 7 days of the transaction.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>Non-Refundable Services</h2>
        <p>The following services are strictly non-refundable:</p>
        <ul>
          <li>Services consumed or marked as delivered</li>
          <li>Listings that were live for more than 48 hours</li>
          <li>Promotional add-ons like featured property boosts</li>
          <li>Rent paid to property owners via Totomart payment gateway</li>
        </ul>
      </Section>

      <Section data-aos="fade-up">
        <h2>Cancellation Policy</h2>
        <p>
          You may cancel any paid service prior to its activation. Once a service (e.g., rent agreement creation or
          featured listing) has been initiated, cancellation may not be allowed.
        </p>
        <p>
          For rent transactions, Totomart acts as a facilitator. Any disputes regarding cancellation of rent payments
          must be resolved between tenant and property owner directly.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>How to Request a Refund</h2>
        <p>
          To initiate a refund, please write to <strong>support@totomart.in</strong> with the following details:
        </p>
        <ul>
          <li>Registered email ID and phone number</li>
          <li>Transaction ID / Order reference</li>
          <li>Service availed and date of transaction</li>
          <li>Brief description of issue or reason for refund</li>
        </ul>
        <p>
          Refunds, if approved, will be processed within **7-10 business days** via the original mode of payment.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>Disputes and Chargebacks</h2>
        <p>
          In case of payment disputes, users are encouraged to contact Totomart support before initiating chargebacks.
          Raising false chargebacks without contacting us may result in account suspension or legal action.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>Contact Us</h2>
        <p>
          For any questions or concerns about this policy, please reach out to:
        </p>
        <p>
          <strong>Totomart Customer Support</strong><br />
          Email: support@totomart.in<br />
          Phone: +91-XXXXXXXXXX<br />
          Address: No. 71, Appar Street, Thiruvalleswarar Nagar, Thirumangalam, Anna Nagar, Chennai – 600040
        </p>
      </Section>

      <FooterNote data-aos="fade-in">
        <p>Totomart – Transparent Property Transactions. Zero Brokerage. Total Peace of Mind.</p>
      </FooterNote>
    </Wrapper>
  );
};

export default RefundPolicy;

// Styled-components
const Wrapper = styled.div`
  max-width: 1000px;
  margin: auto;
  padding: 3rem 1.5rem;
  font-family: 'Segoe UI', sans-serif;
  color: #333;
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 2rem;

  h1 {
    color: #e53935;
    font-size: 2.2rem;
  }

  p {
    color: #555;
    font-size: 1rem;
    margin-top: 0.5rem;
  }
`;

const Section = styled.section`
  margin-bottom: 2.5rem;

  h2 {
    color: #b71c1c;
    font-size: 1.5rem;
    margin-bottom: 0.6rem;
  }

  p {
    font-size: 1rem;
    line-height: 1.7;
    color: #444;
  }

  ul {
    margin: 1rem 0;
    padding-left: 1.5rem;

    li {
      margin-bottom: 0.5rem;
      list-style-type: disc;
    }
  }
`;

const FooterNote = styled.div`
  text-align: center;
  color: #777;
  font-size: 0.95rem;
  margin-top: 3rem;
  border-top: 1px solid #eee;
  padding-top: 1.5rem;
`;
